import { IoIosArrowBack } from 'react-icons/io';
import { useRouter } from 'next/router';
import { TMobileModes } from '@shared/types/frontend';
import useAppDetails from '@/hooks/utilities/useAppDetails';
export default function SettingsBackArrow() {
  const {
    setMobileMode
  } = useAppDetails();
  const router = useRouter();
  const query = router.query;
  const handleOnClick = () => {
    const prevMode = query.prev_m_mode as TMobileModes ?? 'home';
    setMobileMode(prevMode);
    router.push(`/home${!!prevMode && prevMode !== 'home' ? `?m_mode=${prevMode}` : ''}`, undefined, {
      shallow: true
    });
  };
  return <div className='w-fit flex items-center bg-genius-blue rounded-full pl-2 pr-3.5 py-1' onClick={handleOnClick} data-sentry-component="SettingsBackArrow" data-sentry-source-file="SettingsBackArrow.tsx">
      <IoIosArrowBack className='w-[16px] text-genius-cream' width={20} height={18} data-sentry-element="IoIosArrowBack" data-sentry-source-file="SettingsBackArrow.tsx" />
      <div className='text-[14px]'>Back</div>
    </div>;
}